const isNilOrEmpty = (value) => value === null || value === undefined || value === '';

const normalizeBooleanValue = (value) => {
  if (typeof value === 'boolean') {
    return value ? 1 : 0;
  }

  if (typeof value === 'number') {
    return value ? 1 : 0;
  }

  const normalizedValue = value?.toString().trim().toLowerCase();

  if (normalizedValue === 'true' || normalizedValue === 'enabled' || normalizedValue === 'active') {
    return 1;
  }

  return 0;
};

const normalizeValueForSort = (value, type = 'string') => {
  if (isNilOrEmpty(value)) {
    return null;
  }

  if (type === 'date') {
    const timestamp = new Date(value).getTime();

    return Number.isNaN(timestamp) ? null : timestamp;
  }

  if (type === 'number') {
    const normalizedNumber = Number(value);

    return Number.isNaN(normalizedNumber) ? null : normalizedNumber;
  }

  if (type === 'boolean') {
    return normalizeBooleanValue(value);
  }

  return value.toString().toLowerCase();
};

const getComparableValue = (item, sortKeyConfig = {}) => {
  if (typeof sortKeyConfig.getValue === 'function') {
    return sortKeyConfig.getValue(item);
  }

  return item?.[sortKeyConfig.key];
};

export const sortItemsByConfig = (
  items = [],
  sortData = {},
  sortKeys = [],
  ascendingSortValue = 0
) => {
  const normalizedItems = Array.isArray(items) ? items : [];
  const sortKeyConfig = sortKeys[sortData?.sortKey];

  if (!sortKeyConfig) {
    return [...normalizedItems];
  }

  const isAscending = sortData?.sortType === ascendingSortValue;

  return [...normalizedItems].sort((itemA, itemB) => {
    const valueA = normalizeValueForSort(
      getComparableValue(itemA, sortKeyConfig),
      sortKeyConfig.type
    );
    const valueB = normalizeValueForSort(
      getComparableValue(itemB, sortKeyConfig),
      sortKeyConfig.type
    );

    if (valueA === null && valueB === null) {
      return 0;
    }

    if (valueA === null) {
      return 1;
    }

    if (valueB === null) {
      return -1;
    }

    let comparisonResult = 0;

    if (sortKeyConfig.type === 'string') {
      comparisonResult = valueA.localeCompare(valueB);
    } else if (valueA > valueB) {
      comparisonResult = 1;
    } else if (valueA < valueB) {
      comparisonResult = -1;
    }

    return isAscending ? comparisonResult : -comparisonResult;
  });
};
